import initialState from 'store/initialState';
import { getQuestionUrl, getLearningObjectiveUrl } from 'utils/navigation';
import { RESULTS_PATH } from 'constants/navigation';
import { ActionTypes, NavigationActionTypes } from './types';

export default function navigationReducer(
  state = initialState.navigation,
  action: NavigationActionTypes
) {
  switch (action.type) {
    case ActionTypes.URLS_LOADED: {
      const urls = [];
      for (const sectionId in action.payload.sections) {
        if (
          action.payload.sections[sectionId].learningObjective &&
          action.payload.isShowContentPagesEnabled
        ) {
          urls.push(getLearningObjectiveUrl(sectionId));
        }
        action.payload.sections[sectionId].questions.forEach((questionId: string) => {
          urls.push(getQuestionUrl(sectionId, questionId));
        });
      }

      urls.push(RESULTS_PATH);
      return { ...state, ...{ chain: urls } };
    }
    case ActionTypes.NAVIGATED_INSIDE_THE_APP: {
      return { ...state, ...{ prevUrl: action.payload.prevUrl } };
    }
    case ActionTypes.POOL_URL_LOADED: {
      const urls = [];
      for (const poolQuestions in action.payload) {
        if (action.payload[poolQuestions].isPoolQuestion === true) {
          urls.push(
            getQuestionUrl(
              action.payload[poolQuestions].sectionId,
              action.payload[poolQuestions].id
            )
          );
        }
      }

      urls.push(RESULTS_PATH);
      return { ...state, ...{ chain: urls } };
    }
    case ActionTypes.ELEMENT_ID_IN_VIEWPORT_UPDATED: {
      return { ...state, ...{ elementIdInViewport: action.payload.elementIdInViewport } };
    }
    default:
      return state;
  }
}
